import Header from "../../components/Header/Header"
import ItemListContainer from "../../components/ItemListContainer/ItemListContainer"
import Feature from "../../components/Feature/Feature"

const Home = () => {
   return (
      <>
         <Header />
         <Feature />
         <ItemListContainer />
      </>
   )
}

export default Home
